import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Footer from "../../../../../footer.js";
import Header from "../../../../../header/header.js";
import Navvbar from "../../../../../header/Navvbar.js";
import Swal from 'sweetalert2'; // For beautiful alerts
import Sidebar from '../../../../../Sidebar.js';
import './AddCategory.css'; // <--- CSS Import

const AddCategory = () => {
  const navigate = useNavigate();

  // Form fields state
  const [name, setName] = useState('');
  const [sortrank, setSortrank] = useState('');
  const [customId, setCustomId] = useState('');
  const [userLabId, setUserLabId] = useState('');
  const [loading, setLoading] = useState(false);

  // Load userLabId from localStorage on component mount
  useEffect(() => {
    const labId = localStorage.getItem('userLabId');
    
    if (labId) {
      setUserLabId(labId);
    } else {
      Swal.fire({
        title: 'Error!',
        text: 'User information not found. Please login again.',
        icon: 'error',
        confirmButtonColor: '#004aad'
      });
    }
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required field
    if (!name.trim()) {
      Swal.fire({
        title: 'Missing Name',
        text: 'Please enter category name',
        icon: 'warning',
        confirmButtonColor: '#004aad'
      });
      return;
    }
    
    if (!userLabId) {
      Swal.fire({
        title: 'Error!',
        text: 'User information not found. Please login again.',
        icon: 'error',
        confirmButtonColor: '#004aad'
      });
      return;
    }
    
    setLoading(true);
    
    // Prepare data for backend
    const requestData = { 
      name: name.trim(), 
      sortrank: sortrank.trim(), 
      customId: customId.trim(), 
      addedBy: userLabId 
    };
    
    try {
      const response = await fetch('https://hms.backend.hiragroupcloud.com/api/categories', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      
      if (response.ok) {
        // Success: Show SweetAlert for 2 seconds then navigate
        Swal.fire({
          title: 'Success!',
          text: 'Category added successfully!',
          icon: 'success',
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false
        });

        // Reset form
        setName('');
        setSortrank('');
        setCustomId('');

        // Navigate after 2 seconds
        setTimeout(() => {
          navigate('/caseSetting');
        }, 2000);
      } else {
        // Backend error
        Swal.fire({
          title: 'Error',
          text: result.message || 'Failed to add category',
          icon: 'error',
          confirmButtonColor: '#004aad'
        });
      }
    } catch (error) {
      // Network error
      Swal.fire({
        title: 'Network Error',
        text: 'Failed to add category. Please check your connection and try again.',
        icon: 'error',
        confirmButtonColor: '#004aad'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="ac-header">
        <Header />
        <Navvbar />
      </div>
      <div className="ac-wrapper">
        <div className="row ac-row">
          {/* Sidebar */}
          <div className="col-md-2 ac-sidebar">
            <Sidebar />
          </div>

          {/* Main Form */}
          <div className="col-md-10 ac-content">
            <h2 className="ac-heading">Add Display Category</h2>
            
            <h4 className="ac-sub-heading">Details</h4>
            <div className="ac-form-box">
              
              <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                  <label>Name <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    className="form-control ac-form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Sort Rank</label>
                  <input
                    type="text"
                    className="form-control ac-form-control"
                    value={sortrank}
                    onChange={(e) => setSortrank(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <div className="form-group mb-3">
                  <label>Custom ID</label>
                  <input
                    type="text"
                    className="form-control ac-form-control"
                    value={customId}
                    onChange={(e) => setCustomId(e.target.value)}
                    disabled={loading}
                  />
                </div>
                
                {/* Hidden addedBy field */}
                <input type="hidden" value={userLabId} name="addedBy" />
                
                <div className="d-flex gap-2 ac-btn-group">
                  <button 
                    type="submit" 
                    className="btn btn-primary ac-btn"
                    disabled={loading || !userLabId}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Adding...
                      </>
                    ) : 'Submit'}
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-secondary ac-btn"
                    onClick={() => navigate('/caseSetting')}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="ac-footer">
        <Footer />
      </div>
    </>
  );
};

export default AddCategory;